import { useTranslation } from 'react-i18next'
import { AutoComplete } from 'antd'

import { SearchIcon } from '@/components/Icons'

import styles from './B2becSearchSuggestion.module.scss'

function B2becSearchSuggestion({
  shouldShowRightButton,
  shouldDisableInput,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <AutoComplete
      className={styles.autoComplete}
      defaultActiveFirstOption={false}
      suffixIcon={null}
      {...restProps}
    >
      <div className={styles.searchSuggestion}>
        <span className={styles.icon}>
          <SearchIcon />
        </span>
        <input disabled={shouldDisableInput} />
        {shouldShowRightButton && (
          <span className={styles.searchButton}>
            {t('userManagement.search')}
          </span>
        )}
      </div>
    </AutoComplete>
  )
}

export default B2becSearchSuggestion
